/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment, ReactNode } from "react";
import { DateRangeTuple, DateType } from "../../../../globalTypes";
import FlowioDateInput, {
  FlowioDateInputProps,
  DateViewFormat,
} from "../FlowioDateInput";

type DateInputProps = Omit<
  FlowioDateInputProps,
  "value" | "onChange" | "dateFormat" | "defaultValue"
>;

// Todo: Mozna pridat nejakou uncontrolled variantu, ale nenapada me, jak to
// zastresit pod jeden onChange callback
type ControlledOnlyProps = { value: DateRangeTuple };

type Props = ControlledOnlyProps & {
  onChange: (v: DateRangeTuple) => void;
  onBlur?(): void;
  fromProps?: DateInputProps;
  toProps?: DateInputProps;
  dateFormat?: DateViewFormat;
  className?: string;
};

const FlowioDateRange: FC<Props> = ({
  value,
  onChange,
  onBlur,
  toProps,
  fromProps,
  dateFormat,
  className,
}) => {
  const [from, to] = value ?? [null, null];

  type HandleChangeFnc = (newDateValue: string | null) => void;

  const handleChangeFrom: HandleChangeFnc = (newDateFrom) => {
    onChange([newDateFrom, to]);
  };

  const handleChangeTo: HandleChangeFnc = (newDateTo) => {
    onChange([from, newDateTo]);
  };

  const renderInput = (
    val: DateType,
    setter: HandleChangeFnc,
    other?: DateInputProps
  ): ReactNode => (
    <FlowioDateInput
      dateFormat={dateFormat}
      onBlur={onBlur}
      value={val}
      onChange={setter}
      config={{ min: from, max: to }}
      className={className}
      {...other}
      data-cy={`flowio-date-range-input flowio-date-range-input--${val}`}
    />
  );

  return (
    <Fragment>
      {renderInput(from, handleChangeFrom, fromProps)}
      {renderInput(to, handleChangeTo, toProps)}
    </Fragment>
  );
};

export default FlowioDateRange;
export type FlowioDateRangeProps = Props;
